import { styled } from '@mui/material';
import { PropsWithChildren, memo } from 'react';

interface BlurWrapperProps {
  blurred: boolean;
}

const StyledSpan = styled('span')(() => ({
  filter: 'blur(3px)',
  userSelect: 'none',
  pointerEvents: 'none',
}));

export const BlurWrapper = memo(
  ({ children, blurred }: PropsWithChildren<BlurWrapperProps>) => {
    return blurred ? <StyledSpan>{children}</StyledSpan> : <>{children}</>;
  }
);
